import { catchError, filter, switchMap, take } from 'rxjs/operators';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable, of, throwError } from 'rxjs';
import { AuthenticationService } from '../services';
import { ToastService } from '@tcc-mono/shared/ui/services';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private _authService: AuthenticationService,
    private _toast: ToastService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Negeer fouten bij DELETE-polling van asset-collections
    const isDeletePolling =
      req.method === 'GET' &&
      req.url.includes('/asset-collections/');
    if (isDeletePolling) {
      return next.handle(req).pipe(
        catchError(() => of())
      );
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // on first time 401, try to refresh access_token. If that fails, another 401 will be given and a login needs to happen.

        if (
          error.status === 401
          // || error.status === 400
        ) {
          if (req.url.includes('oauth/token')) {
            this._authService.login$();
            return EMPTY;
          }
          return this._authService.tokenRefreshing$.pipe(
            filter(refreshing => !refreshing),
            take(1),
            switchMap(() => this.refreshToken(next, req))
          );
        }

        // 400: Bad Request
        if (error.status === 400) {
          if (req.url.includes('oauth/token')) {
            this._authService.login$();
            return EMPTY;
          }
          if (error.error?.data?.includes('Tenant could not be identified')) {
            this._authService.login$();
            return EMPTY;
          }
          this._toast.show({
            header: error.status.toString(),
            message: error.error?.message || error.message,
            color: 'danger'
          });
          return throwError(() => new Error(error.error?.message || error.message));
        }

        // Overige errors
        const statusText = error.status?.toString() || 'Onbekend';
        const msg = error.error?.message || error.message || 'Er ging iets mis';
        this._toast.show({ header: statusText, message: msg, color: 'danger' });
        return throwError(() => new Error(msg));
      })
    );
  }

  private refreshToken(
    next: HttpHandler,
    req: HttpRequest<any>
  ): Observable<HttpEvent<any>> {
    if (this._authService.refreshToken) {
      this._authService.setTokenRefreshing(true);
      return this._authService.refreshTokens$().pipe(
        take(1),
        switchMap(() => {
          this._authService.setTokenRefreshing(false);
          return next.handle(req);
        })
      );
    } else {
      this._authService.setTokenRefreshing(false);
      this._authService.login$();
      return EMPTY;
    }
  }
}
